var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBottomLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1440,
    height: 51.99,
    viewBox: "0 0 1440 51.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5231",
    transform: "translate(0 -848.01)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3198",
    d: "M0-54.987,1440-18.33V-3H0Z",
    transform: "translate(0 902.997)",
    fill: "#4897d1",
    opacity: 0.378
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2064",
    width: 1440,
    height: 23,
    transform: "translate(0 877)",
    fill: "#4897d1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomLine);
export default __webpack_public_path__ + "static/media/bottom_line.2d67d5f846da591712e19a64c67019b3.svg";
export { ForwardRef as ReactComponent };